import { mediaBreakpointMixin, Spacer, Text } from '@zillow/constellation';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Wrapper = styled(Spacer)`
  display: ${(props) => (props.isMobileHidden ? 'none' : 'initial')};

  @media ${mediaBreakpointMixin('md')} {
    display: initial;
  }
`;

export default function Note({ isMobileHidden = false, firstName, note }) {
  return (
    <Wrapper isMobileHidden={isMobileHidden} marginBottom="sm">
      <Text fontType="bodySmallHeading" as="h4" fontColor="textMedium">
        Note from {firstName}
      </Text>
      <Text>"{note}"</Text>
    </Wrapper>
  );
}

Note.propTypes = {
  firstName: PropTypes.string.isRequired,
  note: PropTypes.string.isRequired,
  isMobileHidden: PropTypes.bool,
};
